import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "description"]

  connect() {
    this.update()
  }

  update() {
    const desc = this.selectTarget.options[this.selectTarget.selectedIndex].dataset.desc
    this.descriptionTarget.textContent = desc
  }
}
